import React from "react";
import "./Footer2.css";
import "./Footer.css";
import logo2 from "../../logo.svg";
import { RiInstagramFill, RiGithubFill, RiLinkedinFill } from "react-icons/ri";
import { ImArrowUp2 } from "react-icons/im";
import { Link, animateScroll as scroll } from "react-scroll";
import { motion } from "framer-motion";


const Footer2 = () => {
  const transition = { duration: 2, type: "spring" };
  const handleClick = () => {
    scroll.scrollToTop();
  };
  return (
    <>
      <section>
        <footer className="top">
          {/* <img src="logo192.png" alt="logo"/> */}
          <motion.img transition={transition} initial={{opacity:0}} whileInView={{opacity:1}} src={logo2} alt="Logo" />
          <div className="links">
            <div>
              <h2 className="fmname"
                style={{
                  textDecorationLine: "underline",
                  textUnderlinePosition: "under",
                  textDecorationStyle: "double",
                }}
              >
                Er.Arvind Kumar
              </h2>
              <p className="fpara">
                “Putting your entire content workflow on steroids. It’s the
                secret weapon of every content professional I know.”
              </p>
            </div>
            <div>
              <h2
                style={{
                  textDecorationLine: "underline",
                  textUnderlinePosition: "under",
                }}
              >
                Quick Links
              </h2>
              <div className="links">
                <div>
                  <Link
                    className="ftlink"
                    activeClass="active"
                    to="about"
                    spy={true}
                  >
                    Resume
                  </Link>
                  <Link
                    className="ftlink"
                    activeClass="active"
                    to="portfolio"
                    spy={true}
                  >
                    My Recent Projects
                  </Link>
                </div>
                <div>
                  <Link
                    className="ftlink"
                    activeClass="active"
                    to="contact"
                    spy={true}
                  >
                    Contact Details
                  </Link>
                  <Link
                    className="ftlink"
                    activeClass="active"
                    to="services"
                    spy={true}
                  >
                    Services
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </footer>
        <footer className="py-3 footers">
          <ImArrowUp2 className="farrow" onClick={handleClick} />
        </footer>
        <footer className="bottom">
          <div className="legal">
            <span>&copy; 2026 | All rights reserved </span>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a> License </a>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a> Terms </a>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a> Privacy </a>
          </div>
          <div className="flinks">
            <a 
              title="Instagram | Arvind"
              href="https://www.instagram.com/er_arvind_sikandra/"
            >
              <RiInstagramFill />
            </a>
            <a
              title="GitHub | Arvind Kumar"
              href="https://github.com/ARVIND67951"
            >
              <RiGithubFill />
            </a>
            <a
              title="LinkedIn | Arvind Kumar"
              href="https://www.linkedin.com/in/arvind-kumar-1112b131a/"
            >
              <RiLinkedinFill />
            </a>
          </div>
          <div style={{ display: "none" }}>
      <a href="https://rajasthanstonearticles.com/" target="_blank" rel="noopener noreferrer">
        Rajasthan Stone Articles
      </a>
      <a href="https://rajasthanstonearticles.com/about.html" target="_blank" rel="noopener noreferrer">
        Deepak Bhai
      </a>
      <a href="https://rajasthanstonearticles.com/service.html" target="_blank" rel="noopener noreferrer">
        stone supplier near me
      </a>
      <a href="https://rajasthanstonearticles.com/buddha-stone.html" target="_blank" rel="noopener noreferrer">
        buddha stone statue
      </a>
      <a href="https://rajasthanstonearticles.com/outdoor-fountain.html" target="_blank" rel="noopener noreferrer">
        stone fountain
      </a>
      <a href="https://rajasthanstonearticles.com/tample-gate.html" target="_blank" rel="noopener noreferrer">
        temple gate
      </a>
      <a href="https://rajasthanstonearticles.com/murti.html" target="_blank" rel="noopener noreferrer">
        indian idol season 15 winner
      </a>
      <a href="https://rajasthanstonearticles.com/cnc-design.html" target="_blank" rel="noopener noreferrer">
        modern cnc design
      </a>
      <a href="https://rajasthanstonearticles.com/contact.html" target="_blank" rel="noopener noreferrer">
        rajasthan stone house
      </a>
    </div>
        </footer>
      </section>
    </>
  );
};

export default Footer2;
